import { css } from "@emotion/css";
import { Spacing } from "@snapchat/snap-design-system";

export const enableWrapperCss = css`
    display: flex;
    gap: ${Spacing.LG}px;
    align-items: center;
    justify-content: flex-end;

    width: 100%;
`;
